import ajax from '@/lib/ajax'

/**
 * 读取电话随访数据
 */
export async function QueryTelephoneFollowList(payload: any) {
    let res = await ajax.post('/api/services/app/TelephoneFollow/QueryTelephoneFollowList', payload)
    return res.data.result
}


// WEBPACK FOOTER //
// ./src/api/follow/telephoneFollow/index.ts